export const base64ToFile = (imgStr: string): Blob => {
  const base64Image = imgStr.split(',')[1];
  const sliceSize = 1024;
  const byteChars = window.atob(base64Image);
  const byteArrays: Uint8Array[] = [];

  for (let offset = 0, len = byteChars.length; offset < len; offset += sliceSize) {
    const slice = byteChars.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: 'image/jpeg' });
  const imageFile = new File([blob], `${Date.now()}.jpg`, {
    type: 'image/jpeg',
    lastModified: Date.now(),
  });

  return imageFile;
};
